var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleColourful = function SvgGoogleColourful(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0425 12.2331C23.0425 11.3698 22.9711 10.7398 22.8164 10.0864H12.7568V13.983H18.6615C18.5425 14.9514 17.8997 16.4097 16.4711 17.3897L16.4511 17.5202L19.6317 19.9349L19.8521 19.9564C21.8758 18.1247 23.0425 15.4297 23.0425 12.2331Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.756 22.5001C15.6488 22.5001 18.0773 21.5667 19.8512 19.9567L16.4702 17.39C15.5655 18.0083 14.3512 18.44 12.756 18.44C9.92268 18.44 7.51795 16.6083 6.66073 14.0767L6.53508 14.0871L3.22782 16.5955L3.18457 16.7133C4.94645 20.1433 8.56549 22.5001 12.756 22.5001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66099 14.0765C6.4348 13.4232 6.3039 12.7231 6.3039 11.9998C6.3039 11.2764 6.4348 10.5765 6.64909 9.92313L6.6431 9.78398L3.29438 7.23535L3.18482 7.28642C2.45866 8.70977 2.04199 10.3081 2.04199 11.9998C2.04199 13.6915 2.45866 15.2897 3.18482 16.7131L6.66099 14.0765Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.756 5.55997C14.7679 5.55997 16.125 6.41163 16.8989 7.12335L19.9227 4.23C18.0656 2.53834 15.6489 1.5 12.756 1.5C8.56552 1.5 4.94646 3.85665 3.18457 7.28662L6.64885 9.92332C7.51797 7.39166 9.92272 5.55997 12.756 5.55997Z",
    fill: "#EB4335"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleColourful);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "googleColourful.7fcb86be9e12469289b5d6d0db532b26.svg";